const categories = [
  "Education",
  "Eating out",
  "Groceries",
  "Home",
  "Health",
  "Entertainment"
];

export default categories;
